import { adminClient as apolloClient } from '@/store/apollo';

import IndicatorsGql from '@/store/graphql/system/queries/Indicators.gql';

export default {
    fetchList: variables =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: IndicatorsGql,
                    variables
                })
                .then(({ data }) => resolve(data.Indicators))
                .catch(err => reject(err));
        })
};
